module.exports = __webpack_public_path__ + "media/images/contacts/kamill-669cffef2e8dc662dbd6ef62968fb420.png";